export default "__VITE_ASSET__CKpgpwGC__"